"use strict";

// ---------------------------------------------------
// Load Super Class

var SoaModel = require('bunsen/models/SoaModel');

// ---------------------------------------------------
// Module Definition

/**
 * This model stores data about the relationship
 * between an item and a category. It is the model
 * for the {@link ItemCategories} collection
 * @class ItemCategory
 * @extends SoaModel
 */
var ItemCategory = module.exports = SoaModel.extend();

// ---------------------------------------------------
// Dependencies

var _ = require('underscore');
var Category = require('./Category');
var Backbone = require('dibs-backbone');

// ---------------------------------------------------
// Define Module Instance Properties

_.extend(ItemCategory.prototype, /** @lends ItemCategory.prototype */{
    relations: [
        { key: 'category', type: Backbone.One, relatedModel: Category }
    ],
    /**
     * @returns {Category}
     */
    getCategory : function () {
        return this.get('category');
    },
    /**
     * @returns {string}
     */
    getCategoryKey : function () {
        return this.get('category.key');
    },
    /**
     * Get the precedence of an ItemCategory
     * @returns {number}
     */
    getPrecedence: function () {
        return this.get('precedence');
    },
    /**
     * @param {string} key
     * @returns {ItemCategory}
     */
    resetCategoryWithKey: function (key) {
        var category = this.getCategory();
        var attrs = {key: key};
        if (!category) {
            this.set('category', attrs);
            return this;
        }
        category.clear({ silent: true }).set({
            key: key
        });
        return this;
    }
});

/**
 * @static
 * @memberOf ItemCategory
 * @param {string} key
 * @param {number} precedence
 * @returns {ItemCategory}
 */
ItemCategory.createWithKeyAndPrecedence = function (key, precedence) {
    return new ItemCategory({
        precedence: precedence,
        category: {
            key: key
        }
    });
};



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/inventory/ItemCategory.js
// module id = 2648
// module chunks = 64